import { usePartnerConfig } from '~/stores/usePartnerConfig';
import { LandingType } from '~/enums/LandingType';

export default defineNuxtRouteMiddleware((to, from) => {
  const { landing } = usePartnerConfig();

  if (landing.value === LandingType.BLACKPROXY) {
    return navigateTo('/login');
  }
});